import { render, staticRenderFns } from "./b44.vue?vue&type=template&id=5ce6169e&scoped=true"
import script from "./b44.vue?vue&type=script&lang=js"
export * from "./b44.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce6169e",
  null
  
)

export default component.exports